import { OverviewContentWrapper } from "./OverviewContentWrapper";

export const StorageImsOverviewContent = () => {
  return (
    <OverviewContentWrapper>
      <section>
        <h3 className="text-xl font-semibold mb-2">
          Enport OTD IMS M-Files – How It Works
        </h3>
        <p>
          The Enport OTD IMS M-Files Agent is a specialized assistant for storage operations that answers questions using indexed IMS documents, OTD normative guidance, and M-Files metadata to deliver source-grounded responses.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold mb-2">Limitations</h3>
        <ul className="list-disc list-inside space-y-1">
          <li>
            It only searches content in configured IMS/OTD indexes and M-Files sites assigned to the user (or manually selected sites)
          </li>
          <li>
            User uploads are disabled for this use case, so it cannot analyze ad hoc files from end users
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-semibold mb-2">
          Best Practices for Effective Use
        </h3>
        <ul className="list-disc list-inside space-y-1">
          <li>
            Be clear and specific when asking your question to help the chatbot
            provide the most accurate response.
          </li>
          <li>
            Try to add the deal id to your request when possible. Use similar
            wording as expected in the stored documents
          </li>
          <li>
            For broader or unclear questions, the chatbot may ask for
            clarification or default to creating a support ticket.
          </li>
        </ul>
      </section>
    </OverviewContentWrapper>
  );
};
